import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FileModule } from '@techspert-io/files';
import { BannerService } from '@techspert-io/growthbook';
import { PatternsModule } from '@techspert-io/patterns';
import { TranscriptionModule } from '@techspert-io/transcriptions';
import { ExpertEchoComponent } from '../../public/opportunity/expert-list/expert/expert-echo/expert-echo.component';
import { ExpertFilesComponent } from '../../public/opportunity/expert-list/expert/expert-files/expert-files.component';
import { ExpertQuotesComponent } from '../../public/opportunity/expert-list/expert/expert-quotes/expert-quotes.component';
import { ExpertEchoMarkdownPipe } from '../../public/opportunity/expert-list/pipes/expert-echo-markdown.pipe';
import { QuoteTimestampPipe } from '../../public/opportunity/expert-list/pipes/quote-timestamp.pipe';
import { SharedModule } from '../../shared/shared.module';
import { AddRespondentComponent } from './components/add-respondent/add-respondent.component';
import { AddRespondentBulkUploadWorkflowComponent } from './components/add-respondent/bulk-upload-workflow/bulk-upload-workflow.component';
import { AddRespondentLoadingStateComponent } from './components/add-respondent/loading-state/add-respondent-loading-state.component';
import { DataCaptureComponent } from './components/data-capture/data-capture.component';
import { DataSheetComponent } from './components/data-sheet/data-sheet.component';
import { DeleteRespondentConfirmationComponent } from './components/delete-respondent-confirmation/delete-respondent-confirmation.component';
import { DeleteSheetConfirmationComponent } from './components/delete-sheet-confirmation/delete-sheet-confirmation.component';
import { EditSheetConfirmationComponent } from './components/edit-sheet/edit-sheet-confirmation/edit-sheet-confirmation.component';
import { EditSheetComponent } from './components/edit-sheet/edit-sheet.component';
import { QuestionNodeComponent } from './components/re-orderable-theme/question-node/question-node.component';
import { ReorderableExpansionPanelsComponent } from './components/re-orderable-theme/re-orderable-theme.component';
import { RegenerateAnswerConfirmationComponent } from './components/regenerate-answer-confirmation/regenerate-answer-confirmation.component';
import { SheetFilterComponent } from './components/sheet-filter/sheet-filter.component';
import { SheetGetStartedComponent } from './components/sheet-get-started/sheet-get-started.component';
import { SkeletonDataCaptureComponent } from './components/skeleton-data-capture/skeleton-data-capture.component';
import { SkeletonVerbatimSummarisedComponent } from './components/skeleton-verbatim-summarised/skeleton-verbatim-summarised.component';
import { ViewAnswerComponent } from './components/view-answer/view-answer.component';
import { ViewRespondentComponent } from './components/view-respondent/view-respondent.component';
import { RespondentAnswerPipe } from './pipes/respondent-answer.pipe';
import { RespondentMatchLabelPipe } from './pipes/respondent-match-label.pipe';
import { RespondentMatchStatusClassPipe } from './pipes/respondent-match-status-class.pipe';
import { RespondentStatusPipe } from './pipes/respondent-status.pipe';
import { TimestampPipe } from './pipes/timestamp.pipe';
import { DataCaptureSheetService } from './services/data-capture-sheet.service';
import { ExternalTranscriptValidationService } from './services/external-transcript-validation.service';
import { ThemeValidationService } from './services/theme-validator.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    FileModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatStepperModule,
    MatCheckboxModule,
    SharedModule,
    MatExpansionModule,
    DragDropModule,
    MatTooltipModule,
    MatRadioModule,
    MatListModule,
    TranscriptionModule,
    PatternsModule,
  ],
  declarations: [
    DataCaptureComponent,
    SheetGetStartedComponent,
    AddRespondentComponent,
    AddRespondentBulkUploadWorkflowComponent,
    AddRespondentLoadingStateComponent,
    EditSheetComponent,
    EditSheetConfirmationComponent,
    ViewRespondentComponent,
    DeleteSheetConfirmationComponent,
    DataSheetComponent,
    ReorderableExpansionPanelsComponent,
    SkeletonDataCaptureComponent,
    SkeletonVerbatimSummarisedComponent,
    ViewAnswerComponent,
    RespondentStatusPipe,
    RespondentMatchLabelPipe,
    RespondentMatchStatusClassPipe,
    TimestampPipe,
    ExpertQuotesComponent,
    ExpertEchoComponent,
    ExpertFilesComponent,
    DeleteRespondentConfirmationComponent,
    QuestionNodeComponent,
    SheetFilterComponent,
    RegenerateAnswerConfirmationComponent,
    ExpertEchoMarkdownPipe,
    QuoteTimestampPipe,
    RespondentAnswerPipe,
  ],
  exports: [
    DataCaptureComponent,
    ExpertQuotesComponent,
    ExpertEchoComponent,
    ExpertFilesComponent,
    ExpertEchoMarkdownPipe,
    QuoteTimestampPipe,
    RespondentAnswerPipe,
  ],
  providers: [
    ExternalTranscriptValidationService,
    ThemeValidationService,
    DataCaptureSheetService,
    BannerService,
  ],
})
export class DataCaptureModule {}
